import React from 'react'

export const CampaignIcon = props => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_14259_121622)">
        <path
          d="M10.9626 7.25942V11.7039M7.99967 4.29646V11.7039M5.03671 8.7409V11.7039M7.99967 14.6668C5.2221 14.6668 3.83331 14.6668 2.85973 13.9595C2.5453 13.731 2.2688 13.4545 2.04035 13.1401C1.33301 12.1665 1.33301 10.7777 1.33301 8.00016C1.33301 5.22258 1.33301 3.83379 2.04035 2.86022C2.2688 2.54579 2.5453 2.26928 2.85973 2.04084C3.83331 1.3335 5.2221 1.3335 7.99967 1.3335C10.7773 1.3335 12.166 1.3335 13.1396 2.04084C13.454 2.26928 13.7306 2.54579 13.959 2.86022C14.6663 3.83379 14.6663 5.22258 14.6663 8.00016C14.6663 10.7777 14.6663 12.1665 13.959 13.1401C13.7306 13.4545 13.454 13.731 13.1396 13.9595C12.166 14.6668 10.7773 14.6668 7.99967 14.6668Z"
          stroke="#004360"
          stroke-width="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14259_121622">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
